import { render, staticRenderFns } from "./ZeroxaModule.vue?vue&type=template&id=14be3ec4&"
import script from "./ZeroxaModule.vue?vue&type=script&lang=js&"
export * from "./ZeroxaModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports